import { render, staticRenderFns } from "./NotesItem.vue?vue&type=template&id=dfc42f22&scoped=true&"
import script from "./NotesItem.vue?vue&type=script&lang=js&"
export * from "./NotesItem.vue?vue&type=script&lang=js&"
import style0 from "./NotesItem.vue?vue&type=style&index=0&id=dfc42f22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfc42f22",
  null
  
)

export default component.exports